import React from 'react';
import SignupHeader from '../components/SignupHeader/SignupHeader'; // Corrected import
import DemoForm from '../components/DemoForm/DemoForm';
import SignupFooter from '../components/SignupFooter/SignupFooter';

const RequestDemoPage = () => {
    return (
        <div className="signup-container">
            <SignupHeader title="Request a Demo" /> {/* Use the reusable component */}
            <main className="signup-main">
                <DemoForm />
            </main>
            <SignupFooter />
        </div>
    );
};

export default RequestDemoPage;